import ApplicationComponent from "legacy/ApplicationComponent"
import FormGroup from "legacy/FormGroup"
import { validatorFactory } from "legacy/validatorFactory"
import PropTypes from "prop-types"
import React from "react"

import Modal from "src/components/Modal"

class LoaMigrationModal extends ApplicationComponent {
  constructor(props) {
    super(props)
    this.state = {
      showModal: false,
      checkBox: false,
      spaceDeleteCheckBox: false,
    }
    this.validator = validatorFactory({ autoForceUpdate: this })
    this.openModal = this.openModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
  }

  closeModal() {
    this.setState({ showModal: false })
    this.validator.hideMessages()
  }

  openModal() {
    this.setState({ showModal: true })
  }

  disableButtonState() {
    if (this.props.hasSpaceGeometries) {
      return !this.state.checkBox || !this.state.spaceDeleteCheckBox
    } else {
      return !this.state.checkBox
    }
  }

  renderModal() {
    return (
      <Modal
        isOpen={this.state.showModal}
        onClose={this.closeModal}
        maxWidth="50vw"
      >
        <Modal.Header title="Upgrade to New Format" />
        <Modal.Body>
          <div className="mb-4">
            We know that assigning boats on a linear dock can feel like a game
            of tetris, and our new tool can help. Upgrade your Linear Dockage
            space groups and transfer their existing assigned reservations.
          </div>
          <div className="mb-4">
            This upgrade helps you assign reservations to linear docks, while
            showing the order of the boats in relation to other reservations. By
            knowing the exact location of these reservations, we&apos;ll
            automatically calculate remaining footage on your behalf and show
            you where a particular boat could fit on the dock. Here are a few
            other highlights that come with this exciting new tool:
          </div>
          <div className="mb-4">
            <ul>
              <li>Add an (optional) buffer zone.</li>
              <li>
                Indicate the orientation of the linear dock so that new
                employees are familiar.
              </li>
              <li>
                Indicate if a particular boat will be a portside or starboard
                tie.
              </li>
              <li>
                Decide to overhang a boat on the beginning or end of a dock to
                maximize capacity.
              </li>
            </ul>
          </div>
          <div className="mb-4">
            <a
              href="https://www.loom.com/share/e42a2869f37e425aa3098c19b8c95f22"
              target="_blank"
              rel="noopener noreferrer"
            >
              Watch a demo of the new tool
            </a>
          </div>
          <div className="mb-6">
            Don&apos;t want to assign your reservations in bulk? Reach out to
            your Dockwa Success Manager for information on doing this manually.
          </div>
          <div className="mb-4">
            <h5 className="font-bold">
              Confirm the following to upgrade your space group:
            </h5>
          </div>
          <form id="upgrade-form" action={this.props.endPoint}>
            <div className="mb-8 ml-2 p-1">
              <FormGroup
                inputType="checkbox"
                name="checkBox"
                value={this.state.checkBox}
                onChange={this.handleInputChange}
                className="my-1"
                defaultChecked={false}
                label={
                  <div>
                    I understand that the order of my linear dock reservations
                    may be rearranged starting today
                    <i
                      className="icon icon-info cursor-pointer"
                      data-content="As Dockwa reassigns reservations into the new space group, the order of boats may be shuffled as we automatically optimize for the most available dockage. That said, you will be able to move them around after the fact if you want to make any changes."
                      style={{
                        color: "#A4A4A4",
                        fontSize: ".9em",
                        padding: "0 1rem",
                      }}
                      data-container="body"
                      data-toggle="popover"
                      data-placement="bottom"
                      data-html="true"
                    />
                  </div>
                }
              />
              {this.props.hasSpaceGeometries ? (
                <FormGroup
                  inputType="checkbox"
                  name="spaceDeleteCheckBox"
                  value={this.state.spaceDeleteCheckBox}
                  onChange={this.handleInputChange}
                  className="my-1"
                  defaultChecked={false}
                  label={
                    <div>
                      I understand that this space group and associated spaces
                      will be removed from all marina maps and will have to be
                      replaced manually.
                      <i
                        className="icon icon-info cursor-pointer"
                        data-content="This space group is being deleted and removed from all marina maps. This action cannot be undone. Spaces will be hidden from the assignments page, but can be restored and reassigned to a different space group."
                        style={{
                          color: "#A4A4A4",
                          fontSize: ".9em",
                          padding: "0 1rem",
                        }}
                        data-container="body"
                        data-toggle="popover"
                        data-placement="bottom"
                        data-html="true"
                      />
                    </div>
                  }
                />
              ) : null}
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-tertiary"
            onClick={this.closeModal}
          >
            Nevermind
          </button>
          <button
            type="submit"
            disabled={this.disableButtonState()}
            className="btn btn-primary"
            form="upgrade-form"
          >
            Continue
          </button>
        </Modal.Footer>
      </Modal>
    )
  }

  render() {
    return (
      <div>
        <button
          type="button"
          className="btn btn-primary"
          onClick={this.openModal}
        >
          {" "}
          Upgrade to New Format
        </button>
        {this.renderModal()}
      </div>
    )
  }
}

LoaMigrationModal.propTypes = {
  hasSpaceGeometries: PropTypes.bool,
  endPoint: PropTypes.string.isRequired,
}

export default LoaMigrationModal
